@if (patient) {
  <app-test-form
    action="{{ 'new' | translate }}"
    [patient]="patient"
    [firstTest]="firstTest"
    [mwlItemId]="mwlItemId">
  </app-test-form>
}